import useWindowSize from "./useWindowSize";
import { useMemo } from "react";

export const breakpoints = {
  xxs: 350,
  xs: 425,
  sm: 768,
  md: 1024,
  lg: 1440,
  xl: 2560,
};

const breakpointFromWidth = (width) => {
  if (width <= breakpoints.xs) return "xs";
  if (width <= breakpoints.sm) return "sm";
  if (width <= breakpoints.md) return "md";
  if (width <= breakpoints.lg) return "lg";
  return "xl";
};

const useBreakpoint = () => {
  const { width } = useWindowSize();
  return useMemo(() => breakpointFromWidth(width), [width]);
};

export default useBreakpoint;
